class filmStrip {
  constructor(id, frames, duration, iterations) {
    const spriteFrames = [
      { transform: 'translateY(0)' },
      { transform: 'translateY(-100%)' }   
    ];
    this.element = document.getElementById(id);
    this.animation = this.element.animate(
    spriteFrames, {
      easing: `steps(${frames}, end)`,
      direction: "normal",
      duration: duration,
      playbackRate: 1,
      iterations: iterations
    });
    this.pause();
    this.element.addEventListener("mouseenter", () => this.play());
    this.element.addEventListener("mouseleave", () => this.pause());
  }
  pause() { this.animation.pause(); this.animation.cancel(); }
  play() { this.animation.play(); }
}

const calendar = new filmStrip('calendar-animation', 28, 1000, Infinity);
const stopwatch = new filmStrip('stopwatch-animation', 11, 10000, Infinity);
const brain = new filmStrip('brain-animation', 51, 3000, 1);
const squarePeg = new filmStrip('square-peg-animation', 18, 900, Infinity);
const yoga = new filmStrip('yoga-animation', 10, 500, 1);

// special case to have the yoga animation stop on last frame
yoga.animation.onfinish = () => yoga.element.classList.add('yoga-end');
yoga.animation.oncancel = () => yoga.element.classList.remove('yoga-end');